import * as types from '../../constants/actionTypes';
import initialState from '../initialState';

export default function (state = initialState.productLocations, action) {
   const { payload } = action;

   switch (action.type) {
      case types.LOAD_PRODUCT_LOCATIONS_SUCCESS : {
         return payload.productLocations;
      }
      // case types.ADD_PRODUCT_LOCATION_CATEGORY : {
      //    const index = state.findIndex((pShop) => (
      //       pShop.id === payload.shop_id
      //    ));
      //    if (index > -1) {
      //       // shop already exist. Concat new Category
      //       return [
      //          ...state.slice(0, index),
      //          Object.assign({}, state[index], {
      //             categories: [].concat(
      //                state[index].categories
      //                   ? state[index].categories : [],
      //                {
      //                   id: payload.category_id,
      //                   name: payload.category_name
      //                })
      //          }),
      //          ...state.slice(index + 1)
      //       ];
      //    } else {
      //       // no shop found..
      //       // create new shop with category
      //       let newShop = {
      //          id: payload.shop_id,
      //          name: payload.shop_name,
      //          categories: [
      //             {
      //                id: payload.category_id,
      //                name: payload.category_name
      //             }
      //          ]
      //       };
      //       return state.concat(newShop);
      //    }
      // }
      //
      // case types.ADD_PRODUCT_LOCATION_SUB_CATEGORY : {
      //    const shopIndex = state.findIndex(function (shop) {
      //       return shop.id === payload.shop_id;
      //    });
      //    if (shopIndex > -1) {
      //       // first case: shop present
      //       const categoryIndex = state[shopIndex].categories.findIndex((category) => (
      //          category.id === action.payload.categoryId
      //       ));
      //       if(categoryIndex > -1){
      //          // category present.
      //          const subCategories = state[shopIndex].categories[categoryIndex].subCategories
      //             ? state[shopIndex].categories[categoryIndex].subCategories :
      //             [];
      //       }
      //    }
      //
      //    const newSubCategories = [].concat(subCategories, action.payload.subCategory);
      //    const newCategories =
      //       Object.assign(
      //          {},
      //          state[shopIndex].categories[categoryIndex],
      //          {
      //             subCategories: newSubCategories
      //          });
      //    const newCategoriesArray = [
      //       ...state[shopIndex].categories.slice(0, categoryIndex),
      //       newCategories,
      //       ...state[shopIndex].categories.slice(categoryIndex + 1)
      //    ];
      //    const newShop = Object.assign({}, state[shopIndex], {
      //       categories: newCategoriesArray
      //    });
      //    return [
      //       ...state.slice(0, shopIndex),
      //       newShop,
      //       ...state.slice(shopIndex + 1)
      //    ];
      // }

      default:
         return state;
   }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/productMainEdit/productLocationReducers.js
 **/